import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import SkeletonProgressBar from '../../../../../../../../../components/ProgressBar/Skeleton'
import ProgressBar from '../../../../../../../../../components/ProgressBar'

import { green, orange, red } from '../../../../../../../../../styles/const/colors'

import useStyles from './styles'

function ForecastGoalProgress({ isLoading, forecastGoal }) {
  const classes = useStyles()

  const progressColor = useMemo(() => {
    // It should also show three different colours: If < 0.5 make it red, if > 0.9 make it green, if inbetween make it orange.
    if (forecastGoal < 50) {
      return red
    } else if (forecastGoal > 90) {
      return green
    } else {
      return orange
    }
  }, [forecastGoal])

  return isLoading ? (
    <SkeletonProgressBar className={classes.progressBar} />
  ) : (
    <ProgressBar className={classes.progressBar} value={forecastGoal || 0} activeColor={progressColor} />
  )
}

ForecastGoalProgress.propTypes = {
  isLoading: PropTypes.bool,
  forecastGoal: PropTypes.number
}

export default ForecastGoalProgress
